import React from 'react';
import clsx from 'clsx';

import {Typography} from '@mui/material';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {
	breadcrumbSeparatorClasses,
	getBreadcrumbSeparatorUtilityClass,
	BreadcrumbSeparatorClasses,
	BREADCRUMB_SEPARATOR_CLASS_NAME,
} from './breadcrumbSeparatorClasses';

type UtilityClassProps = WithClasses<BreadcrumbSeparatorClasses, {}>;

const useUtilityClasses = (ownerState: UtilityClassProps) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getBreadcrumbSeparatorUtilityClass, classes);
};

const BreadcrumbSeparatorRoot = styled('li', {
	name: BREADCRUMB_SEPARATOR_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	flex: '0 0 auto',
	padding: theme.spacing(0, 0.5),
}));

export type BreadcrumbSeparatorProps = WithClasses<
	BreadcrumbSeparatorClasses,
	{}
>;

export const BreadcrumbSeparatorPrimitive = ({
	classes: _classes,
	className,
}: BreadcrumbSeparatorProps) => {
	const ownerState: UtilityClassProps = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<BreadcrumbSeparatorRoot
			aria-hidden="true"
			className={clsx(classes.root, className, 'breadcrumb-separator')}
		>
			<Typography variant="body2">/</Typography>
		</BreadcrumbSeparatorRoot>
	);
};

export const BreadcrumbSeparator = BreadcrumbSeparatorPrimitive;

export default BreadcrumbSeparator;
